
export default {
	name: 'DeleteTimeSlotConfirm',
};
